import styled from 'styled-components'
import Typography from 'builder/styles/typography'
import Media from 'builder/styles/media'

export const Container = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
`

export const Image = styled.img`
  width: 104px;
  height: 104px;
  aspect-ratio: 1/1;
`

export const Text = styled.div`
  ${Typography.Subhead}
  text-align: center;

  ${Media.Tablet`
    width: 466px;
  `}

  ${Media.Phone`
    width: 261px;
  `}
`
